module.exports = __webpack_public_path__ + "static/media/yourspace-open-office-desk-on-left.5a80e802.jpg";